<template>
  <v-treeview open-all :items="items">
    <template v-slot:label="{ item }">
      <div
        style="border-radius: 4px"
        class="d-flex justify-space-between align-center px-1"
        :class="item.classText"
      >
        <p class="subheading mb-0" style="max-width: fit-content" :class="item.class">
          {{ item.name }}
        </p>
        <p class="subheading mb-0" style="max-width: fit-content">
          <b>{{ self[item.value] | numeral("0,0") }}</b>
        </p>
      </div>
    </template>
  </v-treeview>
</template>

<script>
import gsap from "gsap";
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      located: 0,
      locatedBlocked: 0,
      locatedBlacklist: 0,
      locatedQuarentine: 0,
      locatedApproachable: 0,
      locatedDealsBlocked: 0,
      locatedWithoutDeals: 0,
      locatedNotNotifiable: 0,
      locatedRecentlyWhatsappOptin: 0,
      locatedWhatsappOptin: 0,
      locatedWhatsappOptout: 0,
      locatedDealsWithoutOp: 0,
      locatedNotApproachable: 0,
      locatedDealsWithoutPolicy: 0,
      items: [
        {
          name: "Localizados",
          value: "animatedLocated",
          class: "font-weight-bold",
          children: [
            {
              name: "Negociáveis",
              value: "animatedLocatedApproachable",
              class: "font-weight-medium",
              classText: "green lighten-5 green--text text--darken-2",
              children: [
                {
                  name: "Whatsapp Opt-in recentes",
                  value: "animatedLocatedRecentlyWhatsappOptin",
                },
                {
                  name: "Whatsapp Opt-in",
                  value: "animatedLocatedWhatsappOptin",
                },
                {
                  name: "Whatsapp Opt-out",
                  value: "animatedLocatedWhatsappOptout",
                },
              ],
            },
            {
              name: "Não negociáveis",
              value: "animatedLocatedNotApproachable",
              class: "font-weight-medium",
              classText: "red lighten-5 red--text text--darken-2",
              children: [
                {
                  name: "Blacklist",
                  value: "animatedLocatedBlacklist",
                },
                {
                  name: "Quarentena",
                  value: "animatedLocatedQuarentine",
                },
                {
                  name: "Bloqueados",
                  value: "animatedLocatedBlocked",
                },
                {
                  name: "Com dívidas bloqueadas",
                  value: "animatedLocatedDealsBlocked",
                },
                {
                  name: "Com dívidas sem operações",
                  value: "animatedLocatedDealsWithoutOp",
                },
                {
                  name: "Com dívidas sem política",
                  value: "animatedLocatedDealsWithoutPolicy",
                },
                {
                  name: "Sem dívida",
                  value: "animatedLocatedWithoutDeals",
                },
                {
                  name: "Não notificáveis",
                  value: "animatedLocatedNotNotifiable",
                },
              ],
            },
          ],
        },
      ],
    };
  },
  computed: {
    self() {
      return this;
    },
    animatedLocated() {
      return this.located.toFixed(0);
    },
    animatedLocatedApproachable() {
      return this.locatedApproachable.toFixed(0);
    },
    animatedLocatedNotApproachable() {
      return this.locatedNotApproachable.toFixed(0);
    },
    animatedLocatedBlacklist() {
      return this.locatedBlacklist.toFixed(0);
    },
    animatedLocatedQuarentine() {
      return this.locatedQuarentine.toFixed(0);
    },
    animatedLocatedBlocked() {
      return this.locatedBlocked.toFixed(0);
    },
    animatedLocatedDealsBlocked() {
      return this.locatedDealsBlocked.toFixed(0);
    },
    animatedLocatedDealsWithoutOp() {
      return this.locatedDealsWithoutOp.toFixed(0);
    },
    animatedLocatedDealsWithoutPolicy() {
      return this.locatedDealsWithoutPolicy.toFixed(0);
    },
    animatedLocatedWithoutDeals() {
      return this.locatedWithoutDeals.toFixed(0);
    },
    animatedLocatedNotNotifiable() {
      return this.locatedNotNotifiable.toFixed(0);
    },
    animatedLocatedRecentlyWhatsappOptin() {
      return this.locatedRecentlyWhatsappOptin.toFixed(0);
    },
    animatedLocatedWhatsappOptin() {
      return this.locatedWhatsappOptin.toFixed(0);
    },
    animatedLocatedWhatsappOptout() {
      return this.locatedWhatsappOptout.toFixed(0);
    },
  },
  watch: {
    "data.located"(newValue) {
      gsap.to(this.$data, { duration: 0.5, located: newValue ? newValue : 0 });
    },
    "data.located_approachable"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        locatedApproachable: newValue ? newValue : 0,
      });
    },
    "data.located_not_approachable"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        locatedNotApproachable: newValue ? newValue : 0,
      });
    },
    "data.located_blacklist"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        locatedBlacklist: newValue ? newValue : 0,
      });
    },
    "data.located_quarentine"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        locatedQuarentine: newValue ? newValue : 0,
      });
    },
    "data.located_blocked"(newValue) {
      gsap.to(this.$data, { duration: 0.5, locatedBlocked: newValue ? newValue : 0 });
    },
    "data.located_deals_blocked"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        locatedDealsBlocked: newValue ? newValue : 0,
      });
    },
    "data.located_deals_without_op"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        locatedDealsWithoutOp: newValue ? newValue : 0,
      });
    },
    "data.located_deals_without_policy"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        locatedDealsWithoutPolicy: newValue ? newValue : 0,
      });
    },
    "data.located_without_deals"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        locatedWithoutDeals: newValue ? newValue : 0,
      });
    },
    "data.located_not_notifiable"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        locatedNotNotifiable: newValue ? newValue : 0,
      });
    },
    "data.located_recently_whatsapp_optin"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        locatedRecentlyWhatsappOptin: newValue ? newValue : 0,
      });
    },
    "data.located_whatsapp_optin"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        locatedWhatsappOptin: newValue ? newValue : 0,
      });
    },
    "data.located_whatsapp_optout"(newValue) {
      gsap.to(this.$data, {
        duration: 0.5,
        locatedWhatsappOptout: newValue ? newValue : 0,
      });
    },
  },
};
</script>

<style></style>
